<div class="ui active inverted dimmer store-sync-progress-dimmer">
  <gd-sync-progress-bar [label]="label" [percent]="percent"></gd-sync-progress-bar>
</div>
